import React from 'react'
import { Grid, Box, Typography } from '@mui/material'
import TransporterGroupCard from '../cards/TransporterCard'
import { Transporter, TransporterGroup } from '@otw/models'

interface GroupsProps {
  transporterGroups: TransporterGroup[]
  transporters: Transporter[]
  searchTerm: string
  transporterGroupAvgReadyToInProgressMsById: Record<string, number>
  onEditGroup: (group: TransporterGroup) => void
  onDeleteGroup: (groupId: string) => void
  onOpenTemplateConfig?: (companyId: string) => void
}

const Groups: React.FC<GroupsProps> = ({
  transporterGroups,
  transporters,
  searchTerm,
  transporterGroupAvgReadyToInProgressMsById,
  onEditGroup,
  onDeleteGroup,
  onOpenTemplateConfig,
}) => {
  // Filter groups based on search term
  const filteredGroups = transporterGroups.filter(group =>
    group.name.toLowerCase().includes(searchTerm.toLowerCase())
  )

  return (
    <Box>
      {filteredGroups.length > 0 ? (
        <Grid container spacing={2}>
          {filteredGroups.map((group) => (
            <Grid item xs={12} sm={6} md={4} key={group.id}>
              <TransporterGroupCard
                group={group}
                transporters={transporters}
                avgReadyToInProgressMs={transporterGroupAvgReadyToInProgressMsById[group.id]}
                onEditGroup={onEditGroup}
                onDeleteGroup={onDeleteGroup}
                onOpenTemplateConfig={onOpenTemplateConfig}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            {searchTerm ? 'No groups found matching your search' : 'No transporter companys yet'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {searchTerm ? 'Try adjusting your search terms' : 'Create your first transporter company to get started'}
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export default Groups
